import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20fashion%20and%20streetwear%20themed%20background%20with%20soft%20warm%20beige%20and%20sage%20green%20gradient%20tones%2C%20subtle%20geometric%20shapes%20and%20floating%20sneaker%20silhouettes%2C%20minimal%20editorial%20style%2C%20clean%20modern%20aesthetic%2C%20gentle%20depth%20of%20field%2C%20harmonious%20calm%20composition&width=1600&height=900&seq=hero-01&orientation=landscape"
          alt="USFans Spreadsheet resource hub background"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-primary-700">
          <i className="ri-sparkling-line" />
          {t('hero.eyebrow')}
        </span>

        <h1 className="mt-6 text-3xl font-extrabold leading-tight text-background-50 md:text-5xl">
          {t('hero.title')}
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap sm:w-auto"
          >
            <i className="ri-table-line text-base" />
            {t('hero.primaryCta')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="flex w-full items-center justify-center gap-2 rounded-md border border-background-100/60 bg-background-50/10 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20 whitespace-nowrap sm:w-auto"
          >
            <i className="ri-shopping-cart-line text-base" />
            {t('hero.secondaryCta')}
          </a>
        </div>

        <p className="mt-6 text-xs text-background-200">{t('hero.trust')}</p>
      </div>
    </section>
  );
}